import { isFunction } from 'lodash';
import React from 'react';
import { Router } from 'react-router';

import Provider from './Provider';
import { createElement, createHistory } from './router';
import { createStore } from './store';
import { setTheme } from './theme/actions';
import { triggerPageView } from '../middleware/pageView/actions';
import { ErrorBoundary } from '../Shared/ErrorBoundary';
import apolloClient from './apolloClient';

export default function wrapWithStore({
    component: Component,
    initialState,
    postGaCustomMiddleware,
    preGaCustomMiddleware,
    reducers,
    routes,
    theme,
    pageName,
    messages,
    locale,
}) {
    const store = createStore({
        initialState,
        reducers,
        preGaCustomMiddleware,
        postGaCustomMiddleware,
        pageName,
    });

    if (theme) {
        store.dispatch(setTheme(theme));
    }

    store.dispatch(triggerPageView());

    const render = () => {
        if (isFunction(Component)) {
            /** Component class */
            return (<Component />);
        } else if (Component) {
            /** JSX instance */
            return Component;
        } else if (routes) {
            return (
                <Router
                    createElement={createElement}
                    history={createHistory(store)}
                    routes={routes}
                />
            );
        }
    };

    return (
        <Provider
            client={apolloClient}
            locale={locale}
            messages={messages}
            store={store}
        >
            <ErrorBoundary>
                {render()}
            </ErrorBoundary>
        </Provider>
    );
}
